<div class="scrollable-wrapper">
  <div class="user-update-page pt-3 pt-md-4">
    <user-form
      [initialSection]="initialSection"
      (afterSave)="save()"
      (afterDelete)="goToLoginPage()"
      (navigateToElement)="navigateToElement($event)"
    ></user-form>
  </div>
</div>
